import { render, staticRenderFns } from "./Confirm.vue?vue&type=template&id=6ea0183c&scoped=true&"
var script = {}
import style0 from "./Confirm.vue?vue&type=style&index=0&id=6ea0183c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea0183c",
  null
  
)

export default component.exports